import { Card, Col, Row, Skeleton } from "antd";

export const WorkflowStatusesLoader = () => {
  return (
    <Row gutter={[24, 24]} wrap={false}>
      <Col flex="0 0 340px">
        <Skeleton active paragraph={{ rows: 8 }} />
      </Col>
      <Col flex={1}>
        <Card bordered={false} bodyStyle={{ padding: 16 }}>
          <Skeleton active paragraph={{ rows: 10 }} />
        </Card>
      </Col>
    </Row>
  );
};
